import type { DevEnv } from "@p0security/shared/types/environment";

import type { AwsPartition } from "../util.ts";
import type { AwsPolicyOptions } from "./policies.ts";
import { roleInstallCommands, roleTerraform } from "./shared.ts";

export const iamWriteInstallCommands = (
  context: DevEnv,
  options: AwsPolicyOptions,
  args: {
    gcloudServiceAccountId: string;
    awsAccountId: string;
    awsPartition: AwsPartition;
  }
) => roleInstallCommands("iam-write", context, options, args);

export const iamWriteTerraform = (
  gcloudServiceAccountId: string,
  context: DevEnv,
  options: AwsPolicyOptions,
  awsPartition: AwsPartition
) =>
  roleTerraform(
    "iam-write",
    context,
    options,
    gcloudServiceAccountId,
    awsPartition
  );
